module.exports = __webpack_public_path__ + "img/3.c20ae55e.jpg";